import { Box, Button, CircularProgress, Skeleton, Tooltip } from '@mui/material';
import React from 'react';

const RenderActionButtons = ({ ticket, actions, isLoading }) => {
  if (isLoading) {
    return (
      <Box
        sx={{
          width: '100%',
          marginTop: 3,
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        {Array.from({ length: 6 }).map((_, idx) => (
          <Box key={idx} sx={{ width: 'calc(33.33% - 16px)' }}>
            <Button
              sx={{
                width: '100%',
                height: 100,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: 4,
                cursor: 'pointer',
                gap: 1,
                borderRadius: 2,
                color: 'primary.main',
                fontWeight: 'bold',
                marginBottom: '10px',
              }}
              disabled
              variant="outlined"
            >
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="100%" height={24} />
            </Button>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        marginTop: 3,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      {actions.map((action, idx) => {
        return action.isDisplayed ? (
          <Box key={idx} sx={{ width: 'calc(33.33% - 16px)' }}>
            {/* Tooltip facultatif. Le <span> est requis pour que l'info-bulle
                s'affiche même lorsque le bouton est désactivé (MUI). Un titre
                vide n'affiche aucune info-bulle. */}
            <Tooltip title={action.tooltip || ''} arrow>
              <span style={{ display: 'block', width: '100%' }}>
                <Button
                  startIcon={action.isLoading && <CircularProgress size={20} />}
                  disabled={action.isDisabled || action.isLoading}
                  sx={{
                    width: '100%',
                    height: 100,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    padding: 4,
                    cursor: 'pointer',
                    gap: 1,
                    borderRadius: 2,
                    color: 'primary.main',
                    fontWeight: 'bold',
                    marginBottom: '10px',
                  }}
                  onClick={() => {
                    return action.onClick({ ticket });
                  }}
                  variant="outlined"
                >
                  {!action.isLoading && action.icon}
                  {action.textContent}
                </Button>
              </span>
            </Tooltip>
          </Box>
        ) : (
          <React.Fragment key={idx}></React.Fragment>
        );
      })}
    </Box>
  );
};

export default RenderActionButtons;
